export const en = {
    placeholder_text: 'Select value',
    empty_text: 'Nothing here yet',
};
